import { motion } from "framer-motion";
import React from "react";
import { useEffect, useState } from "react";
import {
  Dec,
  auth_token,
  auth_token_name,
  segment_detail_url,
  segment_id_name
} from "../Webcontroller/Webcontroller";
import "./IntroductionScreen.css";


const containerVariants = {
  hidden: {
    opacity: 0,
    transition: {
      staggerChildren: 0.5,
    },
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      mass: 0.4,
      damping: 8,
      staggerChildren: 0.5,
      when: "beforeChildren",
    },
  },
};

const childVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
};

const IntroductionScreen = () => {
  const vrc_title = "Welcome To Venom Research Centre, Bangladesh".split(" ");

  const [trainData, setTrainData] = useState([]);

  useEffect(() => {
    // Training
    const trainData = new FormData();
    trainData.append(auth_token_name, auth_token);
    trainData.append(segment_id_name, 23);
    trainData.append(Dec, 0);

    fetch(segment_detail_url, {
      method: "POST",
      body: trainData,
    })
      .then((res) => res.json())
      .then((data) => {
        setTrainData(data.data);
      })
      .catch((error) => { });
  }, []);

  return (
    <div className="intro_background_img" style={{ backgroundImage: 'url("https://vrc.cmc.edu.bd/Files/resources/others/welcome_vrc.jpg")' }}>
      <div className="container intro_body">
        <div className=" pt-5 pb-5 introduction-div">
          <h1 className="text-center intro_h1 text-white">
            {vrc_title.map((el, i) => (
              <motion.span
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  duration: 0.25,
                  delay: i / 10,
                }}
                key={i}
              >
                {el}{" "}
              </motion.span>
            ))}
          </h1>

          {trainData.length > 0 ? (
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <div className=" justify-content-start  pb-5">
                {trainData.map((item, index) => (
                  <div
                    key={index}
                    className=""
                  >
                    <motion.div
                      variants={childVariants}
                      className="bg-about-p"
                      dangerouslySetInnerHTML={{ __html: item.details }}
                    />

                  </div>


                ))}
              </div>
            </motion.div>
          ) : (
            <div className="d-flex justify-content-center loading-bg">
              <div className="loading-spinner"></div>
            </div>
          )}


        </div>
      </div>
    </div>
  );
};

export default IntroductionScreen;
